import { cva } from "class-variance-authority";
import { Badge, cn } from "web-design-system";
import { OrderStatus } from "creso-core/types";

const variants = cva("!text-xs w-fit", {
  variants: {
    status: {
      "Under processing": "bg-tag-grey text-tag-grey-foreground",
      "Payment pending": "bg-tag-orange text-tag-orange-foreground",
      "Payment completed": "bg-tag-lime text-tag-lime-foreground",
      Failed: "bg-tag-red text-tag-red-foreground",
      "Allotment done": "bg-tag-green text-tag-green-foreground",
      "Order completed": "bg-tag-slate text-tag-slate-foreground",
    } as Record<OrderStatus, string>,
  },
});

export function OrderStatusBadge({
  status,
  className,
}: {
  status: OrderStatus;
  className?: string;
}) {
  return (
    <Badge
      variant="custom"
      className={cn(variants({ status }), className, "whitespace-nowrap")}
    >
      {status}
    </Badge>
  );
}
